import { PdfLine } from "./pdfReader";
import { mergeAllCells } from "./maccabiPatientReportParser";

export const isMaccabiDayReport = (lines: PdfLine[]) => {
  const titleString = lines?.[0] && mergeAllCells(lines?.[0]);

  return titleString?.includes("עבודה") || false;
};
